import React, { useEffect, useState } from "react";
import FormComponent from "../../../../../components/gernerateForm/FormComponent";
import generateForm02 from "../data/form02.data";

type Props = {
  onSubmit: (value: any) => void;
  isValidateForm: boolean;
  data: any;
  setData: (value: any) => void;
  mainInputValue: any;
  isValudateFile: boolean;
  isCanEdit?: boolean | true
};
const Form02: React.FC<Props> = (props: Props) => {
  const {
    onSubmit,
    isValidateForm,
    data,
    setData,
    mainInputValue,
    isValudateFile,
    isCanEdit
  } = props;

  const [inputValueFormLeave02, setInputValueFormLeave02] = useState({
    information: {
      delegator: "",
      delegator_phone: "",
      during_leave_address: "",
      during_leave_contact: "",
      province: "",
      district: "",
      district_sub: "",
      postcode: "",
    },
  });

  useEffect(() => {
    const information = mainInputValue.information;
    const condition = inputValueFormLeave02.information;

    setData({
      main: information,
      condition: condition,
    });
  }, [inputValueFormLeave02]);

  useEffect(() => {
    if (data?.condition) {
      setInputValueFormLeave02({
        information: data.condition,
      });
    }
  }, []);

  return (
    <FormComponent
      formGenerate={generateForm02}
      inputValue={inputValueFormLeave02}
      setInputValue={setInputValueFormLeave02}
      handleCheckValid={isValidateForm}
      isCanEdit={isCanEdit ?? true}
      permission={"admin"}
    />
  );
};

export default Form02;
